import { useQuery } from '@tanstack/react-query';

import rateGroupService from '~/services/cruises/RateGroupService';

import { rateGroupQueryKeys } from './rateGroupQueryKeys';

export function useGetRatesByGroup(vendorId: string | undefined, rateCodes: ReadonlyArray<string>) {
  return useQuery({
    queryKey: rateGroupQueryKeys.ratesByGroup(vendorId, rateCodes),
    queryFn: async () => {
      const response = await rateGroupService.getRatesByGroup({ vendorId, rateCodes: [...rateCodes] });
      return response.result;
    },
    enabled: !!vendorId && rateCodes.length > 0,
    staleTime: Infinity,
  });
}
